import React from 'react'

export default class AutoComplete extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		var self = this;

		var opts = {
            dataSource: this.props.dataSource,
            filter: "startswith",
            suggest: true,
		}
		if (this.props.dataTextField)
			opts.dataTextField = this.props.dataTextField;
		if (this.props.dataValueField)
			opts.dataValueField = this.props.dataValueField;
		if (this.props.dataSource == undefined)
			opts = {}

		if (this.props.onChange) {
			var { onChange } = this.props;
			opts.change = () => {
				var control = $(self.refs.theInput).data("kendoAutoComplete");
				var symbol = control.value();
				
				if (self.props.forceUpperCase === true) {
					symbol = symbol.toUpperCase();
					control.value(symbol);
				}

				onChange(symbol);
			}
		}

    $(this.refs.theInput).kendoAutoComplete(opts);


		if (this.props.width !== undefined) {
			$(this.refs.theInput).data("kendoAutoComplete").wrapper.width(this.props.width);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dataSource !== this.props.dataSource)
			$(this.refs.theInput).data("kendoAutoComplete")
				.setDataSource(nextProps.dataSource);
	}

	getValue() {
		return $(this.refs.theInput).data("kendoAutoComplete").value();
	}

	setValue(v) {
		return $(this.refs.theInput).data("kendoAutoComplete").value(v);
	}


  render() {
    return (
      <input ref="theInput" />
    );
  }

}

AutoComplete.propTypes = {
	dataSource: React.PropTypes.array,
	forceUpperCase: React.PropTypes.bool,
	dataTextField: React.PropTypes.string,
	dataValueField: React.PropTypes.string,
	onChange: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/react-autocomplete.jsx